import React, { ReactNode, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppState } from "../redux";
import { getCurrentUser } from "../redux/users/actions";
import TempPasswordModal from "../components/forms/TempPasswordModal";

/**
 * Props for the TempPasswordProtection component which wraps protected children elements.
 */
interface TempPasswordProtectionProps {
  children: ReactNode;
}

/**
 * Guards protected routes by prompting users with temporary passwords to update them before proceeding.
 */
const TempPasswordProtection: React.FC<TempPasswordProtectionProps> = ({ children }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state: AppState) => state.user.currentUser);

  const mustUpdatePassword = !!currentUser?.temp_password;

  /**
   * Refreshes the current user once the temporary password flow has been completed.
   */
  const handleSave = useCallback(() => {
    if (!currentUser) {
      return;
    }

    dispatch(
      getCurrentUser({
        ...currentUser,
        temp_password: false,
      })
    );
  }, [dispatch, currentUser]);

  return (
    <>
      {children}
      {currentUser ? (
        <TempPasswordModal
          currentUserId={currentUser.id}
          open={mustUpdatePassword}
          onSave={handleSave}
        />
      ) : null}
    </>
  );
};

export default TempPasswordProtection;
